/*
 * Navigation-menu click tracking: select_content for every top/child/
 * grandchild link in the header. The theme renders menus through ~10
 * different Liquid snippet variants (desktop, mobile, mega menu with
 * images, mega menu without, sub-menu, ...), but every real navigation
 * link across all of them shares the same `hdt-menu-link` or
 * `hdt-mega-heading` class — one delegated click listener covers every
 * variant without touching any of that Liquid or tracking snippet
 * changes/renames across theme updates.
 *
 * Not an ecommerce event (no product/price involved), so it stays
 * outside services/ga4-events/EVENT-CONTRACT.md entirely — GTM owns it
 * like every other merchandising/engagement signal in this file's
 * sibling, babalu-home-impressions.js.
 */
(function () {
  'use strict';

  function push(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function linkName(anchor) {
    var textNode = anchor.querySelector('.hdt-line-clamp, .hdt-menu-link-text') || anchor;
    return (textNode.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function linkId(anchor) {
    try {
      return new URL(anchor.href, window.location.origin).pathname;
    } catch (error) {
      return anchor.getAttribute('href') || '';
    }
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a.hdt-menu-link, a.hdt-mega-heading');
    if (!anchor) return;
    var name = linkName(anchor);
    if (!name) return;
    push('select_content', {
      content_type: 'menu_item',
      item_id: linkId(anchor),
      item_name: name
    });
  }, true);
}());
